<template>
  <div class="fixed inset-0 flex items-center justify-center z-50">
    <div
      class="absolute inset-0 bg-black opacity-50"
      @click="$emit('close')"
    />
    <div class="bg-white p-6 rounded-md shadow-lg z-60 w-1/4 rounded-10">
      <h3 class="text-c24 font-c7 mb-4 border-b py-2 text-left">
        Accès aux données financières
      </h3>
      <div class="mb-4">
        <div class="text-c14 font-c4 mb-5 mt-10 text-left">
          Autoriser cet utilisateur à accéder aux données financières des entreprises gérées
        </div>
        <div class="flex justify-end gap-3 bgAcces px-2 py-4 mt-4 rounded-8">
          <div
            :class="['rounded-10', 'py-1', 'px-4', 'text-c17', 'font-c5', 'cursor-pointer', !isViewer ? 'actif' : '']"
            @click="isViewer = false"
          >
            NON
          </div>
          <div
            :class="['rounded-10', 'py-1', 'px-4', 'text-c17', 'font-c5', 'cursor-pointer', isViewer ? 'actif' : '']"
            @click="isViewer = true"
          >
            OUI
          </div>
        </div>
      </div>
      <div class="flex justify-end">
        <button
          class="mr-2 bgAnnuler px-4 py-2 rounded-8"
          @click="$emit('close')"
        >
          Annuler
        </button>
        <button
          @click="onConfirm"
          class="bgButton text-white px-4 py-2 rounded-8"
        >
          Confirmer
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LimitViewPopup',
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      localIsViewer: false
    }
  },
  computed: {
    displayName() {
      const p = this.item.person || this.item.info?.person || {};
      return `${p.firstName || ''} ${p.lastName || ''}`.trim();
    },
    isViewer: {
      get() {
        return this.localIsViewer
      },
      set(value) {
        this.localIsViewer = value
      }
    }
  },
  watch: {
    item: {
      handler(newItem) {
        console.log('======== ITEM COMPLET ========')
        console.log(newItem)
        console.log('======== newItem.person COMPLET ========')
        console.log(JSON.stringify(newItem.person, null, 2))
        console.log('======== newItem.info COMPLET ========')
        console.log(JSON.stringify(newItem.info, null, 2))
        
        const correctValue = newItem.person?.isViewer ?? newItem.info?.isViewer ?? newItem.isViewer ?? false
        console.log('Valeur correcte trouvée:', correctValue)
        
        this.localIsViewer = correctValue
        console.log('localIsViewer mis à jour à:', this.localIsViewer)
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    onConfirm() {
      const id = this.item.info?.id ?? this.item.id ?? null;
      this.$emit('confirm', { id, isViewer: this.isViewer });
    }
  }
}
</script>

<style scoped>
.z-60 { z-index: 60 }
.noir {
  background-color: #1C1B1F;
  color: white;
}
.actif {
  background-color: #241A72;
  color: white;
}
.bgAcces {
  background-color: #EAECF2;
}
.bgButton {
  background-color: #241A72;
}
.bgAnnuler {
  background-color: #EFF4FB;
  color: black;
}
</style>